import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useGetLeverage } from '../hooks/useGetLeverage';
import { FormValue } from '../type';

export interface QuickItem {
    value: number;
    leverage: number;
}

export interface GroupedQuickList {
    [maxLeverage: number]: QuickItem[];
}
const data: Record<number, QuickItem[]> = {
    50: [
        { value: 10, leverage: 50 },
        { value: 20, leverage: 50 },
        { value: 50, leverage: 20 },
        { value: 100, leverage: 10 },
        { value: 50, leverage: 50 },
        { value: 100, leverage: 50 },
    ],
    20: [
        { value: 10, leverage: 20 },
        { value: 20, leverage: 20 },
        { value: 50, leverage: 20 },
        { value: 100, leverage: 20 },
        { value: 10, leverage: 10 },
        { value: 20, leverage: 10 },
        { value: 50, leverage: 10 },
        { value: 100, leverage: 10 },
    ],
    5: [
        { value: 30, leverage: 5 },
        { value: 50, leverage: 5 },
        { value: 100, leverage: 5 },
        { value: 100, leverage: 2 },
        { value: 200, leverage: 2 },
        { value: 500, leverage: 2 },
    ],
    100: [
        { value: 5, leverage: 50 },
        { value: 10, leverage: 50 },
        { value: 20, leverage: 50 },
        { value: 50, leverage: 20 },
        { value: 100, leverage: 10 },
        { value: 5, leverage: 100 },
        { value: 10, leverage: 100 },
        { value: 20, leverage: 100 },
        { value: 50, leverage: 50 },
        { value: 100, leverage: 50 },
    ],
    150: [
        { value: 5, leverage: 50 },
        { value: 10, leverage: 50 },
        { value: 20, leverage: 50 },
        { value: 50, leverage: 20 },
        { value: 100, leverage: 10 },
        { value: 5, leverage: 100 },
        { value: 10, leverage: 100 },
        { value: 20, leverage: 100 },
        { value: 50, leverage: 50 },
        { value: 100, leverage: 50 },
        { value: 10, leverage: 150 },
        { value: 20, leverage: 150 },
    ],
    250: [
        { value: 10, leverage: 250 },
        { value: 25, leverage: 100 },
        { value: 50, leverage: 50 },
        { value: 50, leverage: 100 },
        { value: 100, leverage: 50 },
        { value: 100, leverage: 25 },
    ],

    500: [
        { value: 20, leverage: 500 },
        { value: 40, leverage: 250 },
        { value: 100, leverage: 100 },
        { value: 200, leverage: 100 },
        { value: 200, leverage: 50 },
        { value: 400, leverage: 25 },
    ],
};

export function useQuickListGroupedByMaxLeverage(
    maxLeverage: number
): QuickItem[] {
    return useMemo(() => {
        return data[maxLeverage];
    }, [maxLeverage]);
}

export function useGetListQuickTrade() {
    const { control } = useFormContext<FormValue>();

    const [pairIndex] = useWatch({
        control,
        name: ['pairIndex'],
    });

    const { maxLeverage } = useGetLeverage(Number(pairIndex));
    const q = useQuickListGroupedByMaxLeverage(maxLeverage);
    const listQuickTrade =
        Number(pairIndex) === 19
            ? [
                  { value: 20, leverage: 150 },
                  { value: 25, leverage: 100 },
                  { value: 50, leverage: 50 },
                  { value: 50, leverage: 100 },
                  { value: 100, leverage: 50 },
                  { value: 100, leverage: 25 },
              ]
            : q;
    return { listQuickTrade };
}
